export enum ProfileEndpoint {
  Base = '/profile',
  Password = '/password',
  Change = '/change',
}
